/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDocumentAttachment = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2h10.414L20 7.586V22h-8v-2h6V9h-5V4H6v3H4zm11 3.414V7h1.586zM4.667 11C3.663 11 3 11.727 3 12.444v4.89C3 18.725 4.26 20 6 20s3-1.274 3-2.667v-6.11h2v6.11C11 19.991 8.678 22 6 22s-5-2.01-5-4.667v-4.889C1 10.462 2.725 9 4.667 9c1.941 0 3.666 1.462 3.666 3.444v4.89c0 1.307-1.128 2.222-2.333 2.222s-2.333-.915-2.333-2.223v-3.666h2v3.666c0 .032.012.078.066.127a.394.394 0 0 0 .267.096c.12 0 .211-.045.267-.096.054-.05.066-.095.066-.127v-4.889c0-.717-.662-1.444-1.666-1.444z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDocumentAttachment as DocumentAttachment };
